import { RootState } from 'App'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'
import { uploadFileAction } from 'store/actions/common'

const appCommentProps = (state: RootState) => {
  return {
    uploadedFileId: state.common.uploadedFile,
    uploadedFileName: Array.isArray(state.common.uploadedFile)
      ? state.common.uploadedFile[0]?.name
      : state.common.uploadedFile?.name,
    uploadedFileUrl: Array.isArray(state.common.uploadedFile)
      ? state.common.uploadedFile[0]?.url
      : state.common.uploadedFile?.url,
    uploadFileLoading: state.common.uploadFileLoading,
  }
}

function appCommentDispatch(dispatch: Dispatch) {
  return bindActionCreators(
    {
      uploadFileAction: uploadFileAction.STARTED,
    },
    dispatch
  )
}

export const AppCommentConnector = connect(appCommentProps, appCommentDispatch)
